import {archiveSvg as Icon__small__archiveSvg} from '../Icon__small/Icon__small--archive.js';

export var archive = {
  name: 'archive',
  category: 'icon',
  colorable: true,
  svg: Icon__small__archiveSvg,
};
